import { render } from "./CSharpIcon.vue?vue&type=template&id=3aad7c36&scoped=true"
import script from "./CSharpIcon.vue?vue&type=script&lang=js"
export * from "./CSharpIcon.vue?vue&type=script&lang=js"

import "./CSharpIcon.vue?vue&type=style&index=0&id=3aad7c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aad7c36"]])

export default __exports__